module.exports = __webpack_public_path__ + "assets/game-type-pronunciation.014cff05.svg";